import { render, staticRenderFns } from "./deleteAllWidgets.vue?vue&type=template&id=c9b1129e&scoped=true"
import script from "./deleteAllWidgets.vue?vue&type=script&lang=js"
export * from "./deleteAllWidgets.vue?vue&type=script&lang=js"
import style0 from "./deleteAllWidgets.vue?vue&type=style&index=0&id=c9b1129e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9b1129e",
  null
  
)

export default component.exports